import type { RegisterTranslations } from '../interfaces/register';

export const registerTranslations: RegisterTranslations = {
  register_button: 'Registrarse',
  create_account_label_prefix: '¿No tienes una cuenta?',
  create_account_label_button: 'Regístrate',
  or_label: 'O',
  input_name_label: 'Nombre',
  input_name_placeholder: 'Ingrese su nombre',
  input_last_name_label: 'Apellido',
  input_last_name_placeholder: 'Ingrese su apellido',
  terms_and_conditions_text:
    'Al registrarte, aceptas nuestros términos y condiciones',
};
